<template>
  <emd-modal
    has-header
    has-footer
    footer-buttons-on-right
    :open="isModalOpen"
    @close="handleClose"
  >
    <template #header>
      <slot
        v-if="$slots.header"
        name="header"
      />
      <emd-text v-else>
        {{ title }}
      </emd-text>
    </template>

    <template #content>
      <div data-testid="modal-content">
        <slot
          v-if="$slots.content"
          name="content"
        />
        <emd-text v-else>
          {{ description }}
        </emd-text>
      </div>
    </template>

    <template #footer>
      <emd-button
        v-if="showButtonClose"
        type="text"
        color="primary"
        data-testid="close-modal"
        @click="handleClose"
      >
        {{ computedButtonExitLabel }}
      </emd-button>

      <slot name="actions" />
    </template>
  </emd-modal>
</template>
<script>
import { EmdButton, EmdModal, EmdText } from 'emerald-vue/src/components'

export default {
  name: 'ModalKeyContainer',

  components: {
    EmdButton,
    EmdModal,
    EmdText
  },

  props: {
    isModalOpen: {
      type: Boolean,
      default: true
    },
    showButtonClose: {
      type: Boolean,
      default: true
    },
    notClose: {
      type: Boolean,
      default: false
    },
    buttonExitLabel: String,
    title: String,
    description: String
  },

  computed: {
    computedButtonExitLabel () {
      return this.buttonExitLabel || this.$t('general.back')
    }
  },

  methods: {
    handleClose () {
      if (!this.notClose) {
        this.$emit('handleClose')
      }
    }
  }
}
</script>
